/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

export const NavigationFonts = (): React.JSX.Element => {
	const epicComponentDomain = process.env.EPIC_COMPONENTS_DOMAIN;

	if (!epicComponentDomain) {
		return <></>;
	}

	return (
		<>
			<link rel="preconnect" href={epicComponentDomain} />
			<link rel="stylesheet" href={epicComponentDomain + "/styles/navigation.css"} />
		</>
	);
};
